import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { array, string, func } from 'prop-types';

const propTypes = {
  tabs: array.isRequired,
  onTabChange: func.isRequired,
  type: string.isRequired,
};

const defaultProps = {
  tabs: [],
};

const findActiveTab = (tabs = [], type) => {
  let tab = tabs.find(({ id }) => id === type);

  if (tab === undefined) {
    if (type.search(/subs/) > -1) {
      if (type.length === 5) {
        return (
          tabs.filter(({ id }) => id === 'subs')[0] &&
          tabs.filter(({ id }) => id === 'subs')[0].tabs.find(({ id }) => id === type[4])
        );
      } else {
        return tabs.find(({ id }) => id === 'subs');
      }
    }

    tab = tabs.filter(({ tabs = [] }) => tabs.find(({ id }) => id === type));

    if (tab && tab[0] && ['landings', 'times'].includes(tab[0].id)) {
      tab = tab[0].tabs.filter(({ id }) => id === type);
    }

    return tab[0];
  }

  return tab;
};

const renderTitle = id => (
  <FormattedMessage id={`statistics.filters.tabs.${id}.theme_3`} defaultMessage={id} />
);

const sorting = [
  'times',
  'offers',
  'flows',
  'countries',
  'devices',
  'pixels',
  'landings',
  'sources',
  'subs',
];

const renderTabs = (items, active, onTabChange) => {
  return (
    <Fragment>
      <Nav className="nav-tabs_big" tabs>
        {items.map(({ id, title, tabs }) => {
          if (id === 'leads') {
            return null;
          }

          if (id === 'times' || id === 'landings') {
            return tabs.map(({ id, title }) => (
              <NavItem key={id}>
                <NavLink
                  className="nav-link"
                  onClick={e => onTabChange(e, id)}
                  active={id === active.id}
                >
                  {renderTitle(id)}
                </NavLink>
              </NavItem>
            ));
          }

          if (id === 'subs') {
            let subs = tabs.map(({ id, title }) => {
              const subsId = 'subs' + id;
              return (
                <NavItem key={subsId}>
                  <NavLink
                    className="nav-link"
                    onClick={e => onTabChange(e, subsId)}
                    active={id === active.id}
                  >
                    {renderTitle('subid')}
                    {id}
                  </NavLink>
                </NavItem>
              );
            });
            subs.push(
              <NavItem key={id}>
                <NavLink
                  className="nav-link"
                  onClick={e => onTabChange(e, id)}
                  active={id === active.id}
                >
                  {renderTitle('subid')}
                </NavLink>
              </NavItem>,
            );
            return subs;
          }

          return (
            <NavItem key={id}>
              <NavLink
                className="nav-link"
                onClick={e => onTabChange(e, id)}
                active={id === active.id}
              >
                {renderTitle(id)}
              </NavLink>
            </NavItem>
          );
        })}
      </Nav>
    </Fragment>
  );
};

const renderDropdown = (items, active, onTabChange, type) => {
  return (
    <UncontrolledDropdown className="nav-tabs-collapse">
      <DropdownToggle tag="span" data-toggle="dropdown" className="dropdown-toggle">
        {active && active.id === 'subs' ? (
          <span>{renderTitle('subid')}</span>
        ) : active && parseInt(active.id) > 0 ? (
          <span>
            {renderTitle('subid')}
            {active.id}
          </span>
        ) : active ? (
          renderTitle(active.id)
        ) : (
          ''
        )}
      </DropdownToggle>
      <DropdownMenu>
        {items.map(({ id, title, tabs }) => {
          if (id === 'leads') {
            return null;
          }

          if (id === 'times' || id === 'landings') {
            return (
              <DropdownItem className="no-padding" key={id} tag="span">
                {tabs.map(({ id, title }) => (
                  <NavLink
                    className="nav-link"
                    onClick={e => onTabChange(e, id)}
                    active={id === active.id}
                    key={id}
                  >
                    {renderTitle(id)}
                  </NavLink>
                ))}
              </DropdownItem>
            );
          }

          if (id === 'subs') {
            let subs = tabs.map(({ id, title }) => {
              const subsId = 'subs' + id;
              return (
                <DropdownItem className="no-padding" key={id} tag="span">
                  <NavItem key={subsId}>
                    <NavLink
                      className="nav-link"
                      onClick={e => onTabChange(e, subsId)}
                      active={id === active.id}
                    >
                      {renderTitle('subid')}
                      {id}
                    </NavLink>
                  </NavItem>
                </DropdownItem>
              );
            });
            subs.push(
              <DropdownItem className="no-padding" key={id} tag="span">
                <NavItem key={id}>
                  <NavLink
                    className="nav-link"
                    onClick={e => onTabChange(e, id)}
                    active={id === active.id}
                  >
                    {renderTitle('subid')}
                  </NavLink>
                </NavItem>
              </DropdownItem>,
            );
            return subs;
          }

          return (
            <DropdownItem className="no-padding" key={id} tag="span">
              <NavLink
                className="nav-link"
                onClick={e => onTabChange(e, id)}
                active={id === active.id}
              >
                {renderTitle(id)}
              </NavLink>
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const StatisticsTabs = ({ tabs, type, onTabChange }) => {
  const active = findActiveTab(tabs, type) || {};
  const sortedTabs = tabs.length ? sorting.map(item => tabs.find(tab => tab.id === item)) : [];
  return (
    <div className="statistics-tabs">
      {renderTabs(sortedTabs, active, onTabChange)}
      {renderDropdown(sortedTabs, active, onTabChange, type)}
    </div>
  );
};

StatisticsTabs.propTypes = propTypes;
StatisticsTabs.defaultProps = defaultProps;

export default StatisticsTabs;
